import styled from "styled-components";

export default styled.div`
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  height: 100%;
  width: 100%;
  background-color: tranparant;
  color: #fff;
  margin: 15px;
  //   font-size: 4em;
`;
